import {Component, ChangeDetectionStrategy} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-session-warning-dialog',
    templateUrl: './session-warning-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SessionWarningDialogComponent {

    constructor(public dialogRef: MatDialogRef<SessionWarningDialogComponent>) {}

    aceptar(): void {
        this.dialogRef.close();
    }
}
